import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=2c5882e1&scoped=true"
var script = {}
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=2c5882e1&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5882e1",
  null
  
)

export default component.exports